import type { AppDispatch, RootState } from '@/shared/store'
import { slidesAdapter } from '../../slide/slideAdapter'
import { currentLayerAdapter, originalLayerAdapter } from '../../layer/layerAdapters'
import { syncSlide } from './syncSlide'

/**
 * Sync all modified slides sequentially.
 */
export const syncAllSlides = () => async (dispatch: AppDispatch, getState: () => RootState): Promise<void> => {
  const state = getState()
  const allSlides = slidesAdapter.getSelectors().selectAll(state.editor.slides)
  const allCurrent = currentLayerAdapter.getSelectors().selectAll(state.editor.layers.current)
  const allOriginal = originalLayerAdapter.getSelectors().selectAll(state.editor.layers.original)

  const modifiedSlides = allSlides.filter((slide) => {
    if (slide.deletedLayerIds.length > 0) return true

    const currentLayers = allCurrent.filter((l) => l.slideId === slide.id)
    const originalLayers = allOriginal.filter((l) => l.slideId === slide.id)

    return JSON.stringify(currentLayers) !== JSON.stringify(originalLayers)
  })

  // Sync each modified slide sequentially
  for (const slide of modifiedSlides) {
    await dispatch(syncSlide({ slideId: slide.id }))
  }
}
